import { createReducer } from '@reduxjs/toolkit';
import { popNotification, pushNotification } from './actions';
import type { NotificationModel } from './types';

interface NotificationsState {
    items: NotificationModel[];
}

export const notificationsReducer = createReducer<NotificationsState>(
    {
        items: [],
    },
    (builder) => {
        builder
            .addCase(pushNotification, (draft, action) => {
                draft.items.push(action.payload);
                draft.items.splice(0, draft.items.length - 3);
            })

            .addCase(popNotification, (draft, action) => {
                draft.items = draft.items.filter((n) => n.id !== action.payload.id);
            });
    },
);
